import { render, staticRenderFns } from "./relatedItems.vue?vue&type=template&id=fd63cf7a&scoped=true"
import script from "./relatedItems.vue?vue&type=script&lang=js"
export * from "./relatedItems.vue?vue&type=script&lang=js"
import style0 from "./relatedItems.vue?vue&type=style&index=0&id=fd63cf7a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd63cf7a",
  null
  
)

export default component.exports